module.exports = __webpack_public_path__ + "static/media/card-stress.0b5b7c68.svg";